const accessToken = process.env.REACT_APP_API_REQUEST_ACCESS_TOKEN;

export const fetchReferrals = async (authUserId: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/referral_data?user_id=${authUserId}`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'GET',
  };

  return fetch(apiURL, requestOptions);
}


export const sendReferralEmail = async (authUserId: string, targetEmail: string) => {
  const apiURL = `${process.env.REACT_APP_API_END_POINT}api/memeverse/send_referral_email`;
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('x-access-token', accessToken);
  if (authUserId) myHeaders.append('x-user-handler-token', authUserId)

  const reqinfo = {
    user_id: authUserId,
    email: targetEmail,
  }

  const requestOptions: RequestInit = {
    headers: myHeaders,
    method: 'POST',
    body: JSON.stringify(reqinfo),
  };

  return fetch(apiURL, requestOptions);
}

// Helper functions
export const isValidEmail: (email: string) => boolean = (email: string) => {
  return !!email && !!(email.toLowerCase()
  .match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ));
}

export const handleSendReferralEmail = async (authUser: any, email: string, refetch, toast, inputRef?, ) => {
  if (isValidEmail(email)) {
    return sendReferralEmail(authUser.uid, email)
    .then((resp) => {
      if (resp.ok) {
        if (toast) toast.success("Invite sent successfully")
        if (refetch) refetch()
        if (inputRef) inputRef.current.value = '';
      } else {
        if (toast) toast.error("Error sending invite")
      }
    }
    ).catch((error) => {
      console.log(error)
      if (toast) toast.error("Error sending invite")
    })
  }
}
